import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Autosuggest from 'react-autosuggest';
import useDebounce from './useDebounce';
import { renderSuggestion } from './transforms';

function sameLatLon(a, b) {
  return (a || []).join(',') === (b || []).join(',');
}

function shortestName(n1, n2) {
  return n2 && n2.length < n1.length ? n2 : n1;
}

function locationMatches(location, jobLocation) {
  if (location === jobLocation) {
    return false;
  }

  if (location.type !== 'job-gb-locations' && jobLocation.type !== 'job-gb-locations') {
    return false;
  }

  if (location.hide || jobLocation.hide) {
    return false;
  }

  if ((location.merged || jobLocation.merged) && !sameLatLon(location.latlon, jobLocation.latlon)) {
    return false;
  }

  if (location.type !== 'city' && jobLocation.type !== 'city') {
    return false;
  }

  if (location.country !== jobLocation.country) {
    return false;
  }

  var locationNames = [location.name.trim(), location.name.split(',')[0].trim()];
  var jobLocationNames = [jobLocation.name.trim(), jobLocation.name.split(',')[0].trim()];
  return locationNames.some(function (locationName) {
    return jobLocationNames.includes(locationName);
  });
}

export var LocationAutosuggest = function LocationAutosuggest(props) {
  var dispatch = props.dispatch,
      handleLocationValues = props.handleLocationValues,
      inputDetails = props.inputDetails,
      maxSuggestions = props.maxSuggestions,
      minQueryLength = props.minQueryLength,
      siteCountry = props.siteCountry,
      SuggestionsContainer = props.SuggestionsContainer,
      suggestions = props.suggestions,
      throttleTimeout = props.throttleTimeout;

  var getLocationSuggestions = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var parameters, res, response, responseSuggestions, filteredSuggestions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: 'active',
                active: true
              });
              _context.prev = 1;
              parameters = "?q=".concat(value).concat(siteCountry ? "&g=".concat(siteCountry) : "").concat(maxSuggestions ? "&l=".concat(maxSuggestions) : '');
              _context.next = 5;
              return fetch("/api/autocomplete/location".concat(parameters), {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                }
              });

            case 5:
              res = _context.sent;
              _context.next = 8;
              return res.json();

            case 8:
              response = _context.sent;
              responseSuggestions = response.results || [];
              filteredSuggestions = responseSuggestions.map(function (location) {
                if (location.hide) {
                  return location;
                }

                var matches = responseSuggestions.filter(function (jobLocation) {
                  return locationMatches(location, jobLocation);
                });

                if (matches.length > 0) {
                  return matches.reduce(function (acc, match) {
                    if (!locationMatches(acc, match)) {
                      return acc;
                    }

                    var _ref2 = match.type === 'job-gb-locations' ? {
                      fqn: match.fqn
                    } : _objectSpread({}, match),
                        type = _ref2.type,
                        other = _objectWithoutProperties(_ref2, ["type"]);

                    match.hide = true;
                    location.merged = true;
                    return _objectSpread(_objectSpread(_objectSpread({}, acc), other), {}, {
                      name: shortestName(location.name, other.name),
                      merged: true
                    });
                  }, _objectSpread({}, location));
                }

                return location;
              }).map(function (location) {
                if (!location.region && !location.county && location.fqn) {
                  return _objectSpread(_objectSpread({}, location), {}, {
                    region: location.fqn.split(':').reverse()[1]
                  });
                }

                return location;
              }).filter(function (suggestion) {
                return !suggestion.hide;
              });
              dispatch({
                type: 'suggestions',
                suggestions: filteredSuggestions
              });
              dispatch({
                type: 'loading',
                loading: false
              });

              if (response.suggestions && response.suggestions.length === 0) {
                dispatch({
                  type: 'error',
                  error: 'No results found'
                });
              }

              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              dispatch({
                type: 'error',
                error: 'No connection'
              });
              dispatch({
                type: 'loading',
                loading: false
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));

    return function getLocationSuggestions(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onSuggestionSelected = function onSuggestionSelected(event, _ref3) {
    var suggestion = _ref3.suggestion;
    var item = {
      location: suggestion.fqn ? suggestion.fqn : null,
      value: suggestion.name,
      coordinates: suggestion.latlon && "".concat(suggestion.latlon[0], ",").concat(suggestion.latlon[1]),
      bbox: suggestion.bbox && "".concat(suggestion.bbox.lat1, ",").concat(suggestion.bbox.lon1, ",").concat(suggestion.bbox.lat2, ",").concat(suggestion.bbox.lon2)
    };
    handleLocationValues(event, item);
    dispatch({
      type: 'loading',
      loading: false
    });
    dispatch({
      type: 'active',
      active: false
    });
  };

  var onSuggestionsClearRequested = function onSuggestionsClearRequested() {
    dispatch({
      type: 'suggestions',
      suggestions: []
    });
  };

  var onBlur = function onBlur(e, _ref4) {
    var highlightedSuggestion = _ref4.highlightedSuggestion;
    dispatch({
      type: 'active',
      active: false
    });
    dispatch({
      type: 'loading',
      loading: false
    });
    return highlightedSuggestion && Boolean(inputDetails.value) ? onSuggestionSelected(e, {
      suggestion: highlightedSuggestion
    }) : onSuggestionsClearRequested();
  };

  var onFocus = function onFocus() {
    return dispatch({
      type: 'active',
      active: true
    });
  };

  var inputProps = _objectSpread(_objectSpread({}, inputDetails), {}, {
    onBlur: onBlur,
    onFocus: onFocus
  });

  var theme = {
    container: 'tds-location-autosuggest__container',
    suggestion: 'tds-location-autosuggest__suggestion',
    suggestionHighlighted: 'tds-location-autosuggest__suggestion--focused',
    suggestionsContainerOpen: 'tds-location-autosuggest__suggestion-container'
  };
  var getLocationSuggestionsDebounced = useDebounce(getLocationSuggestions, throttleTimeout);

  var onSuggestionsFetchRequested = function onSuggestionsFetchRequested(_ref5) {
    var value = _ref5.value;
    dispatch({
      type: 'loading',
      loading: true
    });
    getLocationSuggestionsDebounced(value);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Autosuggest, {
    suggestions: suggestions,
    shouldRenderSuggestions: function shouldRenderSuggestions(query) {
      return query.trim().length >= minQueryLength;
    },
    onSuggestionsFetchRequested: onSuggestionsFetchRequested,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    onSuggestionSelected: onSuggestionSelected,
    getSuggestionValue: function getSuggestionValue(suggestion) {
      return suggestion.name;
    },
    renderSuggestion: renderSuggestion,
    renderSuggestionsContainer: SuggestionsContainer,
    inputProps: inputProps,
    highlightFirstSuggestion: true,
    theme: theme
  }));
};